import React, { useEffect } from "react";
import { TreeSelect } from "primereact/treeselect";
import CustomeButton from "../Button";
import "./style.scss";
import useBlobFilter from "./useBlobFilter";

const BlobFilter = ({
  onApply = () => {},
  onRemove = () => {},
  loading = false,
  showCategory = true,
  showServiceLine = true,
  showYears = true,
  showEntity = true,
  showRequestType = false,
  serviceLine,
  onFilterChange,
  id,
  disabled = false,
  template,
  entityId,
}) => {
  const {
    treeSelectRef,
    distance,
    treeData,
    value,
    onChange,
    applyFilter,
    deSelectAll,
    divRef,
    filterCount = 0,
    extractGroupedValues,
    removeSelectedItem,
    filterValue,
    setFilterValue,
    setValue,
    selectedNodes,
    setSelectedNodes,
  } = useBlobFilter({
    showCategory,
    showServiceLine,
    showYears,
    showEntity,
    onApply,
    serviceLine,
    onFilterChange,
    template,
    showRequestType,
    entityId,
  });
  React.useEffect(() => {
    if (onRemove) onRemove(removeSelectedItem);
  }, [removeSelectedItem, onRemove]);

  return (
    <div
      className={`custom__multiselect blob__filter ${distance < 180 ? "position__left" : ""}`}
      ref={divRef}
    >
      <CustomeButton
        label={`Filters (${filterCount})`}
        icon="pi pi-filter"
        iconPos="right"
        loading={loading}
        onClick={() => treeSelectRef.current?.show()}
        disabled={disabled}
      />

      <TreeSelect
        ref={treeSelectRef}
        value={value}
        onChange={(e) => {
          const grouped = extractGroupedValues(e.value, treeData);
          onChange({ value: e.value, grouped });
          onFilterChange({
            value: e.value,
            grouped,
          });
        }}
        options={treeData}
        selectionMode="checkbox"
        display="chip"
        filter
        filterBy="label"
        className="hidden-treeselect"
        valueTemplate={() => null}
        dropdownIcon={null}
        filterValue={filterValue}
        onFilterValueChange={(e) => setFilterValue(e.value)}
        onHide={() => {
          setFilterValue("");
          setValue(selectedNodes);
        }}
        panelFooterTemplate={() => (
          <div className="filter__action">
            <CustomeButton
              label="Deselect All"
              className="access-btn flex-1"
              onClick={() => {
                deSelectAll();
                treeSelectRef.current?.hide();
              }}
            />
            <CustomeButton
              label="Apply Filters"
              className="access-btn flex-1"
              variant="contained"
              onClick={() => {
                setSelectedNodes(value);
                applyFilter();
                treeSelectRef.current?.hide();
              }}
            />
          </div>
        )}
        panelClassName="custom-blob-filter-tree-panel"
      />
    </div>
  );
};

export default BlobFilter;
